import React, { useEffect, useState } from 'react';
import styles from './styles/CatalogManagement.module.css';
import api from '../../../../services/api';

function ProductModal({ visible, product, onClose, onSave }) {
  const [form, setForm] = useState({
    name: '',
    gtin: '',
    size: '',
    sizeUnit: 'л',
    description: '',
  });

  // Сброс / заполнение формы при открытии модалки
  useEffect(() => {
    if (visible) {
      if (product) {
        setForm({
          name: product.name,
          gtin: product.gtin || '',
          size: String(product.size),
          sizeUnit: product.size_unit,
          description: product.description || '',
        });
      } else {
        setForm({
          name: '',
          gtin: '',
          size: '',
          sizeUnit: 'л',
          description: '',
        });
      }
    }
  }, [visible, product]);

  if (!visible) return null;

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      name: form.name,
      gtin: form.gtin || null,
      size: parseFloat(form.size),
      size_unit: form.sizeUnit,
      description: form.description || null,
    };
    await onSave(payload);
  };

  return (
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <h2>{product ? 'Изменить товар' : 'Добавить товар'}</h2>
        <form className={styles.modalForm} onSubmit={handleSubmit}>
          <input
            name="name"
            placeholder="Название"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            name="gtin"
            placeholder="GTIN"
            value={form.gtin}
            onChange={handleChange}
          />
          <div className={styles.sizeGroup}>
            <input
              name="size"
              type="number"
              step="0.001"
              placeholder="Размер"
              value={form.size}
              onChange={handleChange}
              required
            />
            <select
              name="sizeUnit"
              value={form.sizeUnit}
              onChange={handleChange}
            >
              <option>л</option>
              <option>мл</option>
              <option>кг</option>
              <option>г</option>
            </select>
          </div>
          <textarea
            name="description"
            placeholder="Описание"
            value={form.description}
            onChange={handleChange}
          />
          <div className={styles.modalActions}>
            <button type="submit">Сохранить</button>
            <button type="button" onClick={onClose}>
              Отменить
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function CatalogManagement() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const list = await api.get('/catalog-product/products');
      setProducts(list);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = products.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.gtin || '').includes(search)
  );

  const openModal = product => {
    setEditing(product || null);
    setModalVisible(true);
  };
  const closeModal = () => setModalVisible(false);

  const handleSave = async payload => {
    if (editing) {
      await api.put(`/catalog-product/products/${editing.id}`, payload);
    } else {
      await api.post('/catalog-product/products', payload);
    }
    closeModal();
    loadProducts();
  };

  const handleDelete = async id => {
    if (!window.confirm('Удалить товар?')) return;
    await api.delete(`/catalog-product/products/${id}`);
    loadProducts();
  };

  return (
    <div className={styles.catalog}>
      <header className={styles.header}>
        <h1>Каталог товаров</h1>
        <div className={styles.controls}>
          <input
            type="text"
            placeholder="Поиск по имени или GTIN"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button onClick={() => openModal(null)}>Добавить</button>
        </div>
      </header>

      <section className={styles.gridSection}>
        {loading ? (
          <p>Загрузка...</p>
        ) : (
          <div className={styles.grid}>
            {filtered.map(p => (
              <div key={p.id} className={styles.card}>
                <div className={styles.cardHeader}>
                  <h2>{p.name}</h2>
                  {p.gtin && <span className={styles.gtin}>{p.gtin}</span>}
                </div>
                <div className={styles.cardBody}>
                  <div>{p.size} {p.size_unit}</div>
                  {p.description && <p>{p.description}</p>}
                </div>
                <div className={styles.cardActions}>
                  <button onClick={() => openModal(p)}>Изм.</button>
                  <button onClick={() => handleDelete(p.id)}>✕</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <ProductModal
        visible={modalVisible}
        product={editing}
        onClose={closeModal}
        onSave={handleSave}
      />
    </div>
);
}
